import { RecommendationsSliderTypeKey } from 'corgi-types';

import { useLocalization } from 'common/providers/LocaleProvider';
import type { RecommendationsSliderBaseProps } from '../types';

export const useSliderTitle = (
  type: RecommendationsSliderBaseProps['type'],
  title: RecommendationsSliderBaseProps['title']
) => {
  const { t } = useLocalization();

  if (title) {
    return title;
  } else if (type === RecommendationsSliderTypeKey.Cart) {
    return t('h24_you_might_like_these');
  }

  return null;
};
